import * as types from './mutation-types'

// Roles (binary)
//  000001 - SuperAdmin  (1)
//  000010 - Admin  (2)
//  000100 - Partner (4)
//  001000 - Referrer (8)
//  010000 - Client (16)
//  100000 - Anonymous (32)

const ROLE_MAPPER = {
  'SuperAdministrator': 1,
  'Administrator': 2,
  'Partner': 4,
  'Referrer': 8,
  'Client': 16,
  'ClientAutomation': 32,
  'Anonymous': 64
}

export const toggleSidebar = ({ commit }, config) => {
  if (config instanceof Object) {
    commit(types.TOGGLE_SIDEBAR, config)
  }
}

export const toggleDevice = ({ commit }, device) => commit(types.TOGGLE_DEVICE, device)

export const expandMenu = ({ commit }, menuItem) => {
  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false
    commit(types.EXPAND_MENU, menuItem)
  }
}

export const switchEffect = ({ commit }, effectItem) => {
  if (effectItem) {
    commit(types.SWITCH_EFFECT, effectItem)
  }
}

export const setAuthenticationToken = ({commit}, token) => {
  localStorage.setItem('authenticationToken', token)
  commit('SET_AUTHENTICATION_TOKEN', token)
}

export const removeToken = ({commit}) => {
  localStorage.removeItem('authenticationToken')
  commit('SET_AUTHENTICATION_TOKEN')
}

export const setLoggedRole = ({commit}, role) => {
  localStorage.setItem('loggedRole', ROLE_MAPPER[role])
  commit('SET_LOGGED_ROLE', ROLE_MAPPER[role])
}

export const setLoggedUser = ({commit}, user) => {
  localStorage.setItem('loggedUser', user)
  commit('SET_LOGGED_USER', user)
}

export const removeLoggedUser = ({commit}) => {
  localStorage.removeItem('loggedUser')
  commit('SET_LOGGED_USER')
}

export const setLoggedUserState = ({commit}, userstate) => {
  localStorage.setItem('loggedUserState', userstate)
  commit('SET_LOGGED_USER_STATE', userstate)
}

export const removeLoggedUserState = ({commit}) => {
  localStorage.removeItem('loggedUserState')
  commit('SET_LOGGED_USER_STATE')
}

export const setLoggedStatus = ({commit}, status) => {
  localStorage.setItem('loggedStatus', status)
  commit('SET_LOGGED_STATUS', status)
}

export const removeLoggedStatus = ({commit}) => {
  localStorage.removeItem('loggedStatus')
  commit('SET_LOGGED_STATUS')
}

export const setLoggedId = ({commit}, id) => {
  localStorage.setItem('loggedId', id)
  commit('SET_LOGGED_ID', id)
}

export const removeLoggedId = ({commit}) => {
  localStorage.removeItem('loggedId')
  commit('SET_LOGGED_ID')
}

export const setPermissionMap = ({commit}, map) => {
  localStorage.setItem('permissionMap', map)
  commit('SET_PERMISSION_MAP', map)
}
export const removePermissionMap = ({commit}) => {
  localStorage.removeItem('permissionMap')
  commit('SET_PERMISSION_MAP')
}

export const setClientId = ({commit}, clientid) => {
  localStorage.setItem('clientId', clientid)
  commit('SET_CLIENT_ID', clientid)
}

export const removeClientId = ({commit}) => {
  localStorage.removeItem('clientId')
  commit('SET_CLIENT_ID')
}



// WEBPACK FOOTER //
// ./client/store/actions.js